
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const plateApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listPlates: builder.query ({
      query: (params) => `v2/plate/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Plate"]
    }),
    getPlate: builder.query ({
      query: (plate_id) => `v2/plate/${plate_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Plate"]
    }),
    getPlateItems: builder.query ({
      query: (plate_id) => `v2/itemonplate/?plate=${plate_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["ItemOnPlate"]
    }),
    getPlateActions: builder.query ({
      query: (plate_id) => `v2/action/?plate=${plate_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Action"]
    }),
    getPlateNotes: builder.query ({
      query: (plate_id) => `v2/note/?plate=${plate_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Note"]
    }),
    updatePlate: builder.mutation ({
      query: ({plate_id, data}) => ({
        url: `v2/plate/${plate_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Plate"]
    }),
    deletePlate: builder.mutation ({
      query: (plate_id) => ({
        url: `v2/plate/${plate_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Plate"]
    }),
    createPlate: builder.mutation ({
      query: (data) => ({
        url: `v2/plate/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Plate"]
    }),
  })
})


export const {
  useListPlatesQuery,
  useLazyListPlatesQuery,
  useGetPlateQuery,
  useLazyGetPlateQuery,
  useGetPlateItemsQuery,
  useGetPlateActionsQuery,
  useGetPlateNotesQuery,
  useUpdatePlateMutation,
  useDeletePlateMutation,
  useCreatePlateMutation
} = plateApi
